module.exports = __webpack_public_path__ + "static/media/incMinusSvg.bd3422e2.svg";